/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancySprite } from '@appCanvasCommon/graphics/FancySprite';
import { Texture, Point } from 'pixi.js-legacy';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { TicketContainer } from '@appPlanApplication/tickets/TicketContainer';
import { ComponentManager } from '@appCanvasCommon/component-system/ComponentManager';
import { TicketOverlap } from '../ticket-collision/';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
/**
 * This class is the main representation of a ticket. It has a simple component api to add individual pieces of code as children.
 * Further, it adds some common components for each of the current ticket types.
 *
 * The SpriteTask, SpriteConstraint and SpriteMilestone all extend from this base class
 */
export class SpriteTicket extends FancySprite implements ComponentInterface {
	public override active = true;
	public override visible = true;
	public manager: ComponentManager;
	public managerParent: any;
	public alwaysActive = true;
	public type: string;
	public overlap: any;
	public collidingWith: Map<SpriteTicket, SpriteTicket> = new Map();
	public collidingOverlaps: Map<SpriteTicket, TicketOverlap> = new Map();
	public enableCollisions = true;
	public textureOffset = new Point(0, 0);
	public ticketContainer: TicketContainer;
	/**
	 * @param {PIXI.Texture} ticketShape
	 * @param {CanvasAngularLand} canvasAngularLand
	 * @param {TicketContainer} ticketContainer
	 */
	constructor(ticketShape: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(ticketShape);

		this.ticketContainer = ticketContainer;
		ticketContainer.sprite = this;
	}
	/**
	 * Returns the DataContainer's assigned data, otherwise returns null.
	 * @returns {any}
	 */
	public getData() {
		return this.parent && (this.parent as any).getData ? (this.parent as any).getData() : null;
	}

	/**
	 * Returns the TicketContainer associated with this SpriteTicket.
	 * @returns {TicketContainer}
	 */
	public getTicketContainer(): TicketContainer {
		return this.ticketContainer;
	}
	/**
	 * Called when the associated DataContainer is updated.
	 * @param {CanvasAngularLand} canvasAngularLand
	 * @param {TicketContainer} ticketContainer
	 */
	public updateData(canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		const data = ticketContainer.getData();

		// Set ticket color
		if (!data.isGhost) {
			this.tint = ticketContainer.liveRoleColor;
		}

		// if (data.view.isActualized && !data.isGhost) {
		// 	// Not a ghost and ticket is finished. alpha should be 0.7 according to Davina.
		// 	this.alpha = 0.7;
		// } else if (!data.isGhost) {
		// 	// Ticket is not a ghost and is not finished. Alpha of 1.
		// 	this.alpha = 1.0;
		// } else {
		// 	this.alpha = 0.5;
		// }

		this.ticketContainer = ticketContainer;
	}
	/**
	 * Called each render tick
	 * @param {CanvasAngularLand} canvasAngularLand
	 * @param {TicketContainer} ticketContainer
	 */
	public update(
		canvasAngularLand: CanvasAngularLand,
		ticketContainer: TicketContainer,
		forceDirty: boolean = false
	) {}
	/**
	 * @param {Boolean} [options.children = false] If true, will call destroy on all children as well.
	 * @param {Boolean} [options.texture = false] If true, will destroy the texture as well.
	 * @param {Boolean} [options.baseTexture = false] If true, will destroy the base texture as well.
	 */
	public override destroy(options?: object | boolean): void {
		super.destroy(options);
		if (this.overlap) {
			this.overlap.destroy(options);
		}
	}
}
